import styled from "styled-components";
import { mobile } from "../../../../../../ui/_themes/constants";
import * as helpers from "../../../../../../ui/_themes/helpers";

export const Wrapper = styled.div`
  pointer-events: all;
  color: ${helpers.getColor("headerPluginMenuIcon", "header.pluginMenuIcon")};

  &[disabled] {
    color: ${helpers.getDisabledColor(
      "headerPluginMenuIcon",
      "header.pluginMenuIcon"
    )};
    opacity: ${mobile.disableIconOpacity};
  }

  ${(props: any) =>
    props.icon &&
    `
    background-image: url(${props.icon});
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  `} @media (orientation: landscape) {
    width: ${mobile.landscape.sidePanel.icon.width};
    height: ${mobile.landscape.sidePanel.icon.height};
  }

  @media (orientation: portrait) {
    height: ${mobile.portrait.topPanel.header.icon.height};
    width: ${mobile.portrait.topPanel.header.icon.width};
  }
`;
